import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultTaxData = {
  id: 0,
  enabled: true,
  name: '',
  countryId: undefined,
  rate: 0
};
export const getTaxes = params => request({
  url: '/taxes',
  method: 'get',
  params
});
export const getTaxById = id => request({
  url: `/taxes/${id}`,
  method: 'get'
});
export const updateTax = (id, data) => request({
  url: `/taxes/${id}`,
  method: 'patch',
  data
});
export const deleteTax = id => request({
  url: `/taxes/${id}`,
  method: 'delete'
});
export const createTax = data => request({
  url: '/taxes/',
  method: 'post',
  data
});